module.exports = __webpack_public_path__ + "img/video2.cc8f05a0.png";